import Vue from 'vue';
import {mixin as clickaway} from 'vue-clickaway';

Vue.mixin(clickaway);